import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UserNotificationService } from '@ca/core/services';
import { ClipboardService } from 'ngx-clipboard';
import { LogData } from 'src/app/core/models/log-data.model';

const IDEAL_BREAK_CHAR = ',';

@Component({
    selector: 'ca-logs',
    templateUrl: './logs.component.html',
    styleUrls: ['./logs.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogsComponent {
    @Input() logData: LogData;

    get logName(): string {
        return this.logData.logName;
    }

    get log(): string {
        return this.logData.log;
    }

    get maxLineLength(): number {
        return this.logData.maxLineLength;
    }

    get formattedLog(): string {
        return this.breakCode(this.log);
    }

    constructor(
        private userNotificationService: UserNotificationService,
        private clipboardService: ClipboardService,
    ) {}

    triggerCopyToClipboard(event: MouseEvent): void {
        if (event.target) {
            const textToCopy = (event.target as EventTarget & { innerText: string }).innerText;
            this.clipboardService.copyFromContent(textToCopy);
            this.userNotificationService.showSuccess('GENERAL.PATH_COPIED');
        }
    }

    // break long lines, ideally by next ","
    private breakCode(str: string): string {
        const res: string[] = [];
        const parts = str.split('\n');
        parts.forEach((line: string) => {
            if (line.length < this.maxLineLength) {
                res.push(line);
            } else {
                let start = 0;
                let stop = this.maxLineLength;

                // iterate over long line and push substrings to result array
                while (line?.length > start) {
                    if (start + this.maxLineLength < line?.length) {
                        const add = line.substr(start + this.maxLineLength).indexOf(IDEAL_BREAK_CHAR);
                        const addOption = line.substr(start + this.maxLineLength).indexOf(' ');
                        if (add >= 0 && add < this.maxLineLength) {
                            stop = stop + add + 1;
                        } else if (addOption >= 0 && addOption < this.maxLineLength) {
                            stop = stop + addOption + 1;
                        }
                    }
                    const toPush = start + this.maxLineLength < line?.length ? line.substring(start, stop) : line.substr(start);
                    res.push(toPush);

                    start = stop;
                    stop += this.maxLineLength;
                }
            }
        });
        return res.join('\n');
    }
}
